<template>
  <div :class="['navigation', cssClass]">
    <!-- TODO Text and Images from Prismic and not fix Values -->
    <div class="navigation__bar">
      <div class="container">
        <div class="navigation__bar-left">
          <LanguageSwitch />
          <a href="/"><img class="navigation-logo" src="/images/krienstourismus.jpg" /></a>
          <div class="weather-today" v-if="currentWeather">
            <img :src="iconBaseUrl + currentWeather.weather[0].icon + '.png'" />
            <strong>{{ Math.round(currentWeather.main.temp) }}&deg;</strong>
          </div>
        </div>
        <button v-if="fields.topicLinks" class="navigation__trigger" @click="toggleNavigationOverlay"><i class="material-icons">menu</i></button>
      </div>
    </div>
    <div :class="['navigation__overlay', (isNavigationVisible ? 'state-visible' : 'state-hidden')]">
      <button class="navigation__trigger" @click="toggleNavigationOverlay"><i class="material-icons">close</i></button>
      <div class="container">
        <div class="navigation__topic-nav-container">
          <a v-for="link in fields.topicLinks"
             :key="link.link_text"
             class="btn btn-text-gradient-light"
             :href="link.link.url ? link.link.url : link.anchor_link"
             @click="toggleNavigationOverlay()"
          >
            <h2>{{ link.link_text }}</h2>
          </a>
        </div>
        <div class="navigation__service-nav-container">
          <a v-for="link in fields.serviceLinks"
             :key="link.link_text"
             class="btn btn-text-gradient-light"
             :href="link.link.url ? link.link.url : link.anchor_link"
          >
            <h2>{{ link.link_text }}</h2>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageSwitch from '../elements/LanguageSwitch.vue'
import EventBus from '../EventBus.js'
import axios from 'axios'

export default {
  name: 'Events',
  components: {
    LanguageSwitch
  },
  props: [
    'cssClass'
  ],
  data () {
    return {
      isNavigationVisible: false,
      fields: {
        topicLinks: null,
        serviceLinks: null
      },
      openWeatherApiKey: '8397e7df91f99b4c9ba0f46646528482', // actual key: todo repalce with '3455682ac0087dbc598ef83ab33d7fe6',
      kriensCityCode: '7286225',
      iconBaseUrl: 'https://openweathermap.org/img/wn/',
      currentWeather: null
    }
  },
  created () {
    this.getContent(window.KriensTourismus.language)
    this.getCurrentWeather()
    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
    EventBus.$on(EventBus.constants.HIDE_NAVIGATION, () => this.closeNavigation())
  },
  mounted () {
    
  },
  methods: {
    async getContent (language) {
      let document = await this.$prismic.client.getSingle('navigation', {lang: language})
      if (document) {
        this.fields.topicLinks = document.data.topic_links
        this.fields.serviceLinks = document.data.service_links
      }
    },
    async getCurrentWeather () {
      let response = await axios.get('//api.openweathermap.org/data/2.5/weather?cnt=5&units=metric&appid=' + this.openWeatherApiKey + '&id=' + this.kriensCityCode)
      if (response && response.data) {
        this.currentWeather = response.data
      }
    },
    closeNavigation () {
      if (this.isNavigationVisible) {
        this.toggleNavigationOverlay()
      }
    },
    openNavigation () {
      if (!this.isNavigationVisible) {
        this.toggleNavigationOverlay()
      }
    },
    toggleNavigationOverlay () {
      this.isNavigationVisible = !this.isNavigationVisible
      if (this.isNavigationVisible) {
        document.body.classList.add("state-blured")
      } else {
        document.body.classList.remove("state-blured")
      }
    }
  }
}
</script>